import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';
import type { SingleCardProps } from '../../types';
import { Brand } from '../../components';

export default function SingleCard({ title, description, children }: React.PropsWithChildren<SingleCardProps>) {
  return (
    <ScrollView height={"100%"} width={"100%"} className={"single-card"}>
      <div className="auth-shell">
        <aside className="auth-context">
          <Brand inverse />
          <div className="auth-context-copy">
            <span className="hub-eyebrow">Control plane</span>
            <h1>Integrações Presence, sob controle.</h1>
            <p>Um ambiente central para organizar empresas, lojas e provedores com segurança e rastreabilidade.</p>
          </div>
          <div className="auth-trust-line"><span /> Acesso administrativo protegido</div>
        </aside>
        <main className="auth-form-panel">
          <div className="auth-mobile-brand"><Brand /></div>
          <div className="dx-card content">
            <div className={"header"}>
              <div className={"title"}>{title}</div>
              <div className={"description"}>{description}</div>
            </div>
            {children}
          </div>
        </main>
      </div>
    </ScrollView>
  );
}
